import { Button, Form, Input } from "antd";
import React from "react";
import { SwitchYesNo } from "~/components/form/SwitchYesNo.jsx";
import { ExtrasForm } from "~/components/form/extras.jsx";
import { HelpLine } from "~/components/help/helpLine.jsx";
import { $t } from "~/i18n.js";

export default function StepKado({
  product,
  checkoutItem,
  setCheckoutItem,
  onNext,
  onPrev,
  giftMode,
}) {
  const [form] = Form.useForm();
  const [isGift, setIsGift] = React.useState(checkoutItem.gift_name || false);

  React.useEffect(() => {
    form.setFieldsValue(checkoutItem);
    setIsGift(checkoutItem.gift_name || false);
  }, [checkoutItem, form]);

  const handleFinish = () => {
    onNext && onNext();
  };

  const handleSwitchChange = (checked) => {
    setIsGift(checked);
    if (!checked) {
      form.setFieldsValue({
        gift_name: "",
        gift_email: "",
        gift_message: "",
        extra_guest: {},
      });
      setCheckoutItem({
        ...checkoutItem,
        gift_name: "",
        gift_email: "",
        gift_message: "",
        extra_guest: {},
      });
    }
  };

  return (
    <>
      {!giftMode && (
        <HelpLine style={{ marginBottom: 16 }}>
          {$t(
            "Wil je deze voucher als cadeau versturen naar iemand anders? Vul dan hieronder de gegevens van de ontvanger in."
          )}
        </HelpLine>
      )}

      <Form
        form={form}
        layout="vertical"
        initialValues={checkoutItem}
        onValuesChange={(changed, all) =>
          setCheckoutItem({ ...checkoutItem, ...all })
        }
        requiredMark={false}
        onFinish={handleFinish}
      >
        {!giftMode && (
          <Form.Item label={$t("Is dit een cadeau?")}>
            <SwitchYesNo value={isGift} onChange={handleSwitchChange} />
          </Form.Item>
        )}

        {isGift && (
          <>
            <Form.Item
              label={$t("Naam ontvanger")}
              name="gift_name"
              rules={[
                {
                  required: true,
                  message: $t("Vul de naam van de ontvanger in"),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={$t("Email ontvanger")}
              name="gift_email"
              extra={
                !giftMode &&
                $t(
                  "We sturen de voucher naar dit e-mailadres, die kan zelf de datum en tijd kiezen."
                )
              }
              rules={[
                {
                  required: true,
                  type: "email",
                  message: $t("Vul een geldig e-mailadres in"),
                },
              ]}
            >
              <Input />
            </Form.Item>

            {!giftMode && (
              <Form.Item
                label={$t("Persoonlijk bericht")}
                name="gift_message"
                extra={$t("Dit bericht wordt op de voucher getoond.")}
                rules={[{ required: false }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder={$t(
                    "Schrijf hier een persoonlijk bericht voor de ontvanger..."
                  )}
                />
              </Form.Item>
            )}

            {product?.extras_guest?.length > 0 && (
              <ExtrasForm
                extras={product.extras_guest}
                namePath="extra_guest"
              />
            )}
          </>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 24,
          }}
        >
          <Button onClick={onPrev}>{$t("Terug")}</Button>
          <Button type="primary" htmlType="submit">
            {$t("Volgende")}
          </Button>
        </div>
      </Form>
    </>
  );
}
